module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_21_2.8face9bf.jpeg";